import { useFlag, FEATURE } from '../lib/useFlag';

/**
 * Law-edition flags for the frontend. Mirrors the backend gate on the matters surfaces
 * (requireLawEdition + requireLawFeature(feat:law_master_chart)): `mattersOn` requires BOTH
 * the edition master flag AND the master-chart feature, so it is the single gate the law nav
 * entry and the matters pages read. Default-off while the flags load (useFlag), so a law
 * surface is never revealed speculatively — and absent entirely for a consulting firm.
 */
export function useLawEdition() {
  const editionOn = useFlag(FEATURE.LAW_EDITION);
  const masterChartOn = useFlag(FEATURE.LAW_MASTER_CHART);
  return { editionOn, masterChartOn, mattersOn: editionOn && masterChartOn };
}
